export default {
  TitleControl: '',
  SortValuesControl: 'Não ordenado',
  ShowTitleControl: { checked: false },
  Animate: true,
  PartExtension: 10,
  ColorTheme: { scheme: 'category10' },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  type: 'Pie',
};
